import script from "./PageBlock2.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBlock2.vue?vue&type=script&setup=true&lang=js"

import "./PageBlock2.vue?vue&type=style&index=0&id=08a511c4&lang=less"

const __exports__ = script;

export default __exports__